/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
export const loadScript = src => {
  const script = document.createElement('script');
  script.src = src;
  document.head.appendChild(script);
};
export const clamp = (num, min, max) => Math.min(Math.max(min, num), max);
export const clampToZero = (num, max) => clamp(num, 0, max);
export const closest = (arr, num) => arr.reduce((prev, curr) => {
  return Math.abs(curr - num) < Math.abs(prev - num) ? curr : prev;
});
export const sumWithDoublePrecision = (a, b) => {
  return Math.round(a * 100 + b * 100) / 100;
};
export const calculateVolume = (volume, adjustVolume = 0) => {
  return clampToZero(sumWithDoublePrecision(volume, adjustVolume), 1);
};